export default "__VITE_ASSET__BeDHf2DX__"